/**
 * Get draft sorted data {key: value} from Dy
 * @param {DyCustomJsonResponseType<DyJsonType>} data - response from dy
 * @returns {RawDyVariationsType<DyJsonType>} object
 */
export const sortDyDataBySelector = data =>
    (data?.choices || []).reduce((acc, item) => {
        acc[item.name as string] = item.variations;
        return acc;
    }, {});
